import React from 'react'

interface ILoadingProps {
  body?: string
}

class Loading extends React.Component<ILoadingProps> {
  render() {
    const { body } = this.props
    return (
      <div style={{ minHeight: '200px' }}>
        <h4>Loading Data</h4>
        {body ? <p>{body}</p> : <p>Please wait as we fetch this data</p>}
        <div
          className="loader"
          style={{ fontSize: '1.4em', marginLeft: '1.5%', marginTop: '-2%' }}
        />
      </div>
    )
  }
}

export default Loading
